import { LiveAnnouncer } from '@angular/cdk/a11y';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { DomSanitizer } from '@angular/platform-browser';
import { fetchAuthSession } from 'aws-amplify/auth';
import { map } from 'rxjs';
import { AventuraService } from 'src/app/services/api/aventura.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-dialog-pdf',
  templateUrl: './dialog-pdf.component.html',
  styleUrls: ['./dialog-pdf.component.css'],
})
export class DialogPdfComponent implements OnInit {
  /*
  constructor(private _liveAnnouncer: LiveAnnouncer, @Inject(MAT_DIALOG_DATA) public data: any, private service: AventuraService, private http: HttpClient,
  private pdfService: NgxExtendedPdfViewerService) { } */
  constructor(
    public pdfDialogRef: MatDialogRef<DialogPdfComponent>,
    public dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private _liveAnnouncer: LiveAnnouncer,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: AventuraService,
    private http: HttpClient
  ) {}

  @ViewChild(MatSort) sort: any;
  carga: any;
  cargaImage: any;
  url: string | any;
  blobData: any;
  message: string | null = null;

  private async getAuthHeaders(): Promise<HttpHeaders> {
    try {
      const session = await fetchAuthSession();
      const token = session.tokens?.idToken?.toString();

      if (token) {
        return new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        });
      } else {
        console.warn('⚠️ No hay token disponible para autenticación');
        return new HttpHeaders({
          'Content-Type': 'application/json',
        });
      }
    } catch (error) {
      console.error('❌ Error obteniendo token para headers:', error);
      return new HttpHeaders({
        'Content-Type': 'application/json',
      });
    }
  }

  ngOnInit(): void {
    console.log(this.data.num);
    this.getPdfOS(this.data.num);
  }

  arrayBufferToBase64(buffer: any) {
    let binary = '';
    let bytes = new Uint8Array(buffer);
    let len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  async getPdfOS(id: string) {
    console.log(id);
    try {
      const headers = await this.getAuthHeaders();

      this.http
        .get(`${environment.salesApi}/api/v1/getPdfOS/${id}`, { headers })
        .pipe(
          map((res: any) => {
            this.carga = window.URL.createObjectURL(
              new Blob([new Uint8Array(res.data).buffer], {
                type: 'application/pdf',
              })
            );
            this.blobData = new Blob([new Uint8Array(res.data).buffer]);
            this.cargaImage = this.arrayBufferToBase64(res.data);
            this.url = this.cargaImage;
            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
              'data:application/pdf;base64,' + this.url
            );
            return this.url;
          })
        )
        .subscribe({
          next: (res: any) => {
            console.log(res);
          },
          complete: () => {
            console.log(this.carga);
            console.log(this.cargaImage);
          },
          error: (err) => {
            console.log(err);
            this.message = 'Error al obtener el PDF del Orden de Servicio';
          },
        });
    } catch (error) {
      console.error('Error obteniendo headers de autenticación:', error);
      this.message = 'Error de autenticación al obtener el PDF';
    }
  }
}
